import { createFileRoute, Link } from "@tanstack/react-router";
import { buildSeo } from "@/lib/seo";

// Global catch-all: any URL that doesn't match a defined route renders here
// with a proper noindex head. Placed at the root so it acts as the 404 page.
export const Route = createFileRoute("/$")({
  head: () =>
    buildSeo({
      title: "Página no encontrada · Bizaclia",
      description:
        "La página que buscas no existe o ha sido movida. Vuelve al inicio o explora el portal de locales, oficinas y traspasos.",
      path: "/404",
      noindex: true,
    }),
  component: NotFoundPage,
});

function NotFoundPage() {
  return (
    <main className="flex min-h-[70vh] items-center justify-center bg-background px-4 py-16">
      <div className="max-w-lg text-center">
        <p className="text-sm font-semibold text-primary">404</p>
        <h1 className="mt-2 font-display text-3xl font-bold tracking-tight text-foreground sm:text-4xl">
          Página no encontrada
        </h1>
        <p className="mt-4 text-muted-foreground">
          La página que buscas no existe o ha sido movida. Puedes volver al
          inicio o explorar el portal.
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center justify-center rounded-full bg-primary px-5 py-2.5 text-sm font-semibold text-primary-foreground transition-colors hover:bg-primary/90"
          >
            Ir al inicio
          </Link>
          <Link
            to="/portal/$"
            params={{ _splat: "traspaso" }}
            className="inline-flex items-center justify-center rounded-full border border-input bg-background px-5 py-2.5 text-sm font-semibold text-foreground transition-colors hover:bg-accent"
          >
            Traspasos
          </Link>
          <Link
            to="/portal/$"
            params={{ _splat: "alquiler" }}
            className="inline-flex items-center justify-center rounded-full border border-input bg-background px-5 py-2.5 text-sm font-semibold text-foreground transition-colors hover:bg-accent"
          >
            Alquiler
          </Link>
          <Link
            to="/portal/$"
            params={{ _splat: "venta" }}
            className="inline-flex items-center justify-center rounded-full border border-input bg-background px-5 py-2.5 text-sm font-semibold text-foreground transition-colors hover:bg-accent"
          >
            Venta
          </Link>
        </div>
      </div>
    </main>
  );
}
